import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
import classNames from "classnames";
import { Switch } from "@headlessui/react";
import { useEffect, useState } from "react";
import Store from "../../utils/Store";
import { useStoreState } from "pullstate";
var Toggle = function Toggle(props) {
  var _servicesManager$serv;
  var val = props.value,
    onChange = props.onChange,
    disabled = props.disabled,
    type = props.type,
    label = props.label,
    onInteraction = props.onInteraction,
    id = props.id,
    servicesManager = props.servicesManager;

  // TODO : need to fix it for the notification part
  var isAiToggle = id === "qCT";
  var isNadirToggle = id === "nadir";
  var _useState = useState(val),
    value = _useState[0],
    setValue = _useState[1];
  var SegmentationService = servicesManager === null || servicesManager === void 0 || (_servicesManager$serv = servicesManager.services) === null || _servicesManager$serv === void 0 ? void 0 : _servicesManager$serv.SegmentationService;
  var _useState2 = useState(false),
    isNadirDisabled = _useState2[0],
    setIsNadirDisabled = _useState2[1];
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        nadirSid: s.nadirSid,
        isOverlayVisible: s.isOverlayVisible
      };
    }),
    nadirSid = _useStoreState.nadirSid,
    isOverlayVisible = _useStoreState.isOverlayVisible;
  var activeColorClass = {
    background: {
      isWarning: "bg-[#FF7869]",
      isSuccess: "bg-green-500"
    },
    text: {
      isWarning: "text-[#FF7869]",
      isSuccess: "text-green-500"
    }
  };
  useEffect(function () {
    if (!nadirSid) {
      setIsNadirDisabled(true);
    } else {
      setIsNadirDisabled(false);
    }
  }, [nadirSid]);
  useEffect(function () {
    if (isAiToggle) {
      setValue(isOverlayVisible);
    }
  }, [isOverlayVisible]);
  var onCallback = function onCallback(e) {
    if (isAiToggle) {
      Store.update(function (s) {
        s.isOverlayVisible = !value;
      });
    } else if (isNadirToggle) {
      Store.update(function (s) {
        s.isNadirEnabled = !value;
      });
    }
    setValue(!value);
  };
  var isDisabled = isNadirToggle ? isNadirDisabled : false;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-base font-medium ".concat(activeColorClass["text"][type], " mr-3")
  }, label), /*#__PURE__*/React.createElement(Switch, {
    checked: value,
    onChange: !isDisabled ? onCallback : null,
    className: classNames("relative inline-flex h-5 w-7 flex-shrink-0 cursor-pointer rounded-full border-2 border-gray-500 transition-colors duration-200 ease-in-out bg-black", {
      "opacity-50 !cursor-not-allowed": isDisabled
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames("pointer-events-none relative inline-block h-4 w-4 transform rounded-full bg-gray-500 shadow ring-0 transition duration-200 ease-in-out translate-x-0", _defineProperty({}, "!translate-x-5 ".concat(activeColorClass["background"][type]), value))
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    className: classNames("absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-100 ease-in duration-200", {
      "!opacity-0 !ease-out !duration-100": value
    })
  }, /*#__PURE__*/React.createElement("svg", {
    width: "8",
    height: "2",
    viewBox: "0 0 8 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1H7",
    stroke: "#0C1723",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    className: classNames("absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-0 ease-out duration-100", {
      "!opacity-100 !ease-in !duration-200": value
    })
  }))));
};
Toggle.defaultProps = {
  value: false,
  onChange: function onChange() {},
  disabled: false,
  type: "isSuccess"
};
export default Toggle;